import { useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import { legendSportIcons } from "@/lib/sport-icons";
import { cn } from "@/lib/utils";

const legendItems = [
  { color: "#6366f1", label: "Unreviewed" },
  { color: "#22c55e", label: "Reviewed" },
  { color: "#9E9E9E", label: "Rejected" },
];

export function MapLegend() {
  const [sportIconsOpen, setSportIconsOpen] = useState(false);

  return (
    <div className="absolute bottom-3 left-3 z-10 rounded-lg border bg-card p-3 shadow-md">
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2">
        Legend
      </div>
      <div className="flex flex-col gap-1.5">
        {legendItems.map((item) => (
          <div key={item.label} className="flex items-center gap-2">
            <span
              className="inline-flex h-3 w-3 rounded-full shrink-0"
              style={{ backgroundColor: item.color }}
            />
            <span className="text-xs text-foreground">{item.label}</span>
          </div>
        ))}
      </div>
      <div className="border-t mt-2 pt-2">
        <button
          type="button"
          onClick={() => setSportIconsOpen((o) => !o)}
          className="flex w-full items-center justify-between text-xs font-medium text-muted-foreground uppercase tracking-wide mb-0 cursor-pointer hover:text-foreground transition-colors"
        >
          Sport Icons
          <IconChevronDown
            size={14}
            className={cn(
              "transition-transform duration-200",
              sportIconsOpen && "rotate-180",
            )}
          />
        </button>
        {sportIconsOpen && (
          <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 mt-2">
            {legendSportIcons.map(({ icon: Icon, label }) => (
              <div key={label} className="flex items-center gap-2">
                <Icon size={14} stroke={1.5} className="shrink-0 text-muted-foreground" />
                <span className="text-xs text-foreground whitespace-nowrap">{label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
